import AbstractOperatorApplicationListener
    from "~/operatorApplication/ts/service/comet/AbstractOperatorApplicationListener";
import {ClientUserdataStore} from "~/operatorApplication/ts/store/ClientUserdataStore";
import {toggleArrayElement} from "~/ts/library/ToggleArrayElement";


export default class MessageDialogUpdated extends AbstractOperatorApplicationListener {
    public getAction(): string {
        return "messageDialogUpdated";
    }

    public receive(payload: CometOperatorApplication.MessageDialogUpdatedCometMessageOpenApiModel): void {
        let dialogId = payload.dialog.id;
        let messages = ClientUserdataStore.getMessagesByUsername(payload.username);
        for (let message of messages) {
            if (message.dialog?.id == dialogId) {
                message.dialog = payload.dialog;
            }
        }


        let dialogIds = ClientUserdataStore.getDialogsIdsByUsername(payload.username);
        if (dialogIds.length) {
            let dialogs = ClientUserdataStore.getDialogsByUsername(payload.username);
            dialogs[dialogId] = payload.dialog;
            toggleArrayElement(dialogIds, payload.dialog.id, true);
        }
        let userdata = ClientUserdataStore.getByUsername(payload.username, false);
        if (userdata) {
            if (userdata.lastDialog?.id == dialogId) {
                userdata.lastDialog = payload.dialog;
            }
        }
    }
}